import { render, staticRenderFns } from "./ConsultarContratosOF.vue?vue&type=template&id=2931ffa5&scoped=true"
import script from "./ConsultarContratosOF.vue?vue&type=script&lang=ts"
export * from "./ConsultarContratosOF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931ffa5",
  null
  
)

export default component.exports